module.exports = __webpack_public_path__ + "static/media/volume.b0010cb5.svg";